var map = {
	"./ALC-logo.svg": "c758",
	"./ALCP-logo.svg": "6010",
	"./BNB-logo.svg": "1fb4",
	"./BTC-logo.svg": "3b15",
	"./CBT-logo.svg": "720c",
	"./CCC-logo.svg": "781d",
	"./CCS-logo.svg": "cc86",
	"./DISE-logo.svg": "7b31",
	"./ETH-logo.svg": "4ff2",
	"./EUR-logo.svg": "5fb5",
	"./HLM-logo.svg": "0f95",
	"./LSS-logo.svg": "a008",
	"./MATIC-logo.svg": "5df5",
	"./NKCLC-logo.svg": "b257",
	"./NKCLM-logo.svg": "0420",
	"./PCC-logo.svg": "0a2e",
	"./PLI-logo.svg": "d2ee",
	"./PLP-logo.svg": "f95d",
	"./PRTG-logo.svg": "03d1",
	"./SOLANA-logo.svg": "276c",
	"./STAIKA-logo.svg": "6a12",
	"./TRX-logo.svg": "8b50",
	"./UBP-logo.svg": "2ba1",
	"./UMC-logo.svg": "3f61",
	"./UMCP-logo.svg": "2c59",
	"./UMMC-logo.svg": "5105",
	"./UMSC-logo.svg": "9898",
	"./UMUC-logo.svg": "db2b",
	"./USDT-TRC-logo.svg": "fb18",
	"./USDT-logo.svg": "f586",
	"./W3P-logo.svg": "4ca2",
	"./paycam-logo.svg": "e918",
	"./ub-logo.svg": "b7ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8477";